// @flow
import React, { useEffect, useState } from "react";

import "./download.css";
// import { ProgressBar } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Progress from 'react-progressbar';

import axios from "axios";
import { connect } from "../../../base/redux";
import { FEATURE_CUSTOM_REDUX } from "../../constant";
import { setChatRecordingFiles, setChatRecordingFilesVisible } from "../../redux/tool-webjam/actions";
import { useDispatch } from "react-redux";
import { ct } from "../../constant-Utils";
import { useDevice, usePrevious } from "../../welcome-dashboard/Utils";
import { CURRENT_ROOM_NAME } from "../../../webjam/constant";

const Downloader = (props) => {

    const dispatch = useDispatch();
    const { isMobile } = useDevice();

    const { files, remove, title } = props;

    const [willProcess, setWillProcess] = useState(false)

    useEffect(() => {


        if (props?.timestamp) {
            let room = CURRENT_ROOM_NAME;
            // if (room) {
            //     room = room.substring(1);
            // }
            let time = Math.round(new Date().getTime() / 1000);
            let willTrigger = false;
            let prevConf = sessionStorage.getItem("c_" + room);
            if (prevConf) {
                if (!isNaN(prevConf)) {
                    if (time - prevConf > 1) {
                        willTrigger = true;
                    }
                } else {
                    willTrigger = true;
                }
            } else {
                willTrigger = true;
            }

            if (willTrigger) {
                sessionStorage.setItem("c_" + room, time);
                setWillProcess(true)
            } else {
                setWillProcess(false)
            }
        }
    }, []);

    let prevVisible = usePrevious(props._chatFilesVisible)
    useEffect(() => {
        if (prevVisible != props._chatFilesVisible) {
            if (props._chatFilesVisible) {
                console.log("can visible")
            }
        }
    }, [props._chatFilesVisible])

    const hideRecordingList = () => {
        if (props?.hideRecording) {
            props.hideRecording(true)
        }
        dispatch(setChatRecordingFilesVisible(false));
        dispatch(setChatRecordingFiles(''));
    }

    const { _chatFilesVisible, _chatFiles } = props;
    if (_chatFilesVisible) {
        return (
            <>
                {
                    _chatFiles && _chatFiles.length &&
                    <div className={isMobile ? "downloader downloader-mobile" : "downloader"} style={{ zIndex: "9999" }}>
                        <div className="card">
                            <div className="card-header downloading-header"> {title ? title : ct("rta-trmc.dashboard.myRecording.downloadRecordings")}
                                <div onClick={() => hideRecordingList()} >
                                    <i className="fa fa-times"></i>
                                </div>
                            </div>
                            <ul className="list-group list-group-flush">
                                {_chatFiles && _chatFiles.map((file, idx) => (
                                    <DownloadItem
                                        key={idx}
                                        {...file}
                                    />
                                ))}
                            </ul>
                        </div>
                    </div>
                }
            </>
        );
    } else {
        return (
            <>
                {
                    files && files.length &&
                    <div className={isMobile ? "downloader downloader-mobile" : "downloader"} style={{ zIndex: "9999" }}>
                        <div className="card">
                            <div className="card-header downloading-header"> {title ? title : ct("rta-trmc.dashboard.myRecording.downloadRecordings")}
                                <div onClick={() => hideRecordingList()} >
                                    <i className="fa fa-times"></i>
                                </div>
                            </div>
                            <ul className="list-group list-group-flush">
                                {files && files.map((file, idx) => (
                                    <DownloadItem
                                        key={idx}
                                        // removeFile={() => remove(file.downloadId)}
                                        {...file}
                                    />
                                ))}
                            </ul>
                        </div>
                    </div>
                }
            </>
        );
    }
};

const DownloadItem = ({ name, file, filename }) => {
    const [downloadInfo, setDownloadInfo] = useState({
        progress: 0,
        completed: false,
        total: 0,
        loaded: 0,
    });

    useEffect(() => {
        const options = {
            onDownloadProgress: (progressEvent) => {
                const { loaded, total } = progressEvent;

                setDownloadInfo({
                    progress: Math.floor((loaded * 100) / total),
                    loaded,
                    total,
                    completed: false,
                });
            },
        };

        axios.get(file, {
            responseType: "blob",
            ...options,
        }).then(function (response) {
            const url = window.URL.createObjectURL(
                new Blob([response.data], {
                    type: response.headers["content-type"],
                })
            );

            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();

            setDownloadInfo((info) => ({
                ...info,
                completed: true,
            }));

            // setTimeout(function(){
            //     props.hideRecording(true)
            // },1000)

            // setTimeout(() => {
            //     removeFile();
            // }, 4000);
        });

    }, []);

    const formatBytes = (bytes) => `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    const formatBytes1 = (bytes) => (bytes / (1024 * 1024)).toFixed(2)

    const progress = (formatBytes1(downloadInfo.total) / formatBytes1(downloadInfo.loaded))

    return (
        <li className="list-group-item">
            <div className="row">
                <div className="col-12 d-flex">
                    <div className="d-inline font-weight-bold text-truncate">{name}</div>
                    <div className="d-inline ml-2">
                        <small>
                            {downloadInfo.loaded > 0 && (
                                <>
                                    <span className="text-success">
                                        {formatBytes(downloadInfo.loaded)}
                                    </span>
                                    / {formatBytes(downloadInfo.total)}
                                </>
                            )}

                            {downloadInfo.loaded === 0 && <>{ct("rta-trmc.dashboard.myRecording.initializing")}...</>}
                        </small>
                    </div>
                    <div className="d-inline ml-2 ml-auto">
                        {downloadInfo.completed && (
                            <span className="text-success">
                                {ct("rta-trmc.dashboard.myRecording.completed")}
                            </span>
                        )}
                    </div>
                </div>
                <div className="col-12 mt-2">
                    <Progress
                        completed={downloadInfo.progress}
                    />
                </div>
            </div>
        </li>
    );
};

const mapStateToProps = (state) => {
    return {
        _chatFiles: state[FEATURE_CUSTOM_REDUX].chatFiles,
        _chatFilesVisible: state[FEATURE_CUSTOM_REDUX].chatFilesVisible
    }
}

export default connect(mapStateToProps)(Downloader);